import { Phone, Truck } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/constants";
import { trackPhoneClick } from "../../lib/gtag";

const NAV = [
  { label: "Szolgáltatások", target: "#szolgaltatasok", testid: "nav-services" },
  { label: "Folyamat", target: "#folyamat", testid: "nav-process" },
  { label: "Kapcsolat", target: "#kapcsolat", testid: "nav-contact" },
];

export default function Header({ scrollTo }) {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-3 py-3">
        <a
          data-testid="header-logo"
          href="#hero"
          onClick={(e) => { e.preventDefault(); scrollTo("#hero"); }}
          className="flex items-center gap-2.5 shrink-0"
        >
          <span className="w-10 h-10 rounded-xl bg-[#16A34A] flex items-center justify-center shadow-lg shadow-green-600/25">
            <Truck className="w-5 h-5 text-white" />
          </span>
          <span className="leading-tight text-left">
            <span className="block font-display font-extrabold text-[#1E293B] tracking-tight text-lg">
              Tiszta Tér
            </span>
            <span className="block text-[10px] uppercase tracking-[0.22em] text-[#64748B] font-semibold">
              Lomtalanítás
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((item) => (
            <a
              key={item.target}
              data-testid={item.testid}
              href={item.target}
              onClick={(e) => { e.preventDefault(); scrollTo(item.target); }}
              className="text-sm font-medium text-[#475569] hover:text-[#16A34A] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          data-testid="header-call-button"
          href={PHONE_TEL}
          onClick={trackPhoneClick}
          className="bg-green-600 hover:bg-green-700 text-white font-bold py-2.5 px-4 sm:py-3 sm:px-6 rounded-lg text-sm sm:text-lg flex items-center justify-center gap-2 shadow-lg shadow-green-600/30 animate-pulse transition-colors"
        >
          <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
          <span className="hidden sm:inline">Hívás Most: {PHONE_DISPLAY}</span>
          <span className="sm:hidden">{PHONE_DISPLAY}</span>
        </a>
      </div>
    </header>
  );
}
